export default (url: string) => {
  try {
    return new URL(url).pathname;
  } catch {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch {
      // ignore
    }
  }
  return url;
};
